module.exports = fox._r("images/logo-simple-blue.png", __webpack_public_path__ + "_/common/images/logo-simple-blue.png");


//////////////////
// WEBPACK FOOTER
// ../common/images/logo-simple-blue.png
// module id = 16
// module chunks = 2